const ParagraphLight = props => {
    return (
        <div data-theme="mytheme" class="text-secondary mb-5">{props.children}</div>
    );
};

export default ParagraphLight;